import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class PcSelectionGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.userService.getUserDetails();
    const selectedRole = localStorage.getItem('loginUser');

    // Karan - 🚫 If user is admin (role = 1) AND has NOT selected PC/Admin yet → BLOCK Dashboard
    if (user.userRoles[0].id === 1 && !selectedRole) {
      //Comment
      this.router.navigate(['/pc-selection']);
      return false;
    }

    // ✔ Non-admin OR admin who selected already → Allow Access
    return true;
  }
}
